const APP_DOMAIN = import.meta.env?.VITE_APP_DOMAIN || 'scann3r.ca';

export const buildRestaurantBaseUrl = (slug) => {
  if (!slug) return window.location.origin;

  const hostname = window.location.hostname || '';
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';

  if (isLocal) {
    return `${window.location.protocol}//${window.location.host}`;
  }

  return `https://${slug}.${APP_DOMAIN}`;
};

export const buildAcceptInviteUrl = (slug) => {
  const base = buildRestaurantBaseUrl(slug);
  const hostname = window.location.hostname || '';
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';

  if (isLocal) {
    return `${base}/accept-invite?slug=${encodeURIComponent(slug)}`;
  }

  return `${base}/accept-invite`;
};
